module.exports = __webpack_public_path__ + "img/easter_egg_modal_cover_end_round.6e587d94.png";